import * as Sentry from "@sentry/react";
import { getConfig } from "./config";

// Only initialize Sentry when not in development environment
if (getConfig().shouldEnableSentry) {
  Sentry.init({
    dsn: "https://a0702ddbcdce3fad0a6a4b9d8cf78de8@o1133917.ingest.us.sentry.io/4509667522510848",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}